import { Typography } from '@material-ui/core';
import {
  categorizeOrderInsightRisks,
  getParentSeverity,
  PropertyOrderInsightsProps,
  RiskCategory,
} from 'api/file/interfaces/get-file-order-insights';
import clsx from 'clsx';
import React from 'react';
import OrderInsightAlert from './OrderInsightAlerts';
import OrderInsightsRiskIcon from './OrderInsightsRiskIcon';
import orderInsightStyles from './OrderInsightStyles';

const PolicyLiability: React.FC<PropertyOrderInsightsProps> = ({ property, policyLiabilityJacket, isPdf }) => {
  const classes = orderInsightStyles();
  const { alertRisks, warningRisks, unknownRisks, errorRisks } = categorizeOrderInsightRisks(
    property.risks,
    RiskCategory.PolicyLiability,
  );

  return (
    <div className={classes.brdBtm}>
      <div className={clsx(classes.displayFlex, classes.flexGrow)}>
        <div className={classes.labelCol}>
          <span className={clsx(classes.displayFlex, classes.alignCenter)}>
            <OrderInsightsRiskIcon
              isPdf={isPdf}
              riskSeverity={getParentSeverity(property.risks, RiskCategory.PolicyLiability)}
            />
            <Typography
              variant="h4"
              color="textSecondary"
              className={clsx(classes.ml1, classes.fontSizeNormal, isPdf ? classes.bold : '')}
            >
              Policy Liability:
            </Typography>
          </span>
        </div>
        <div>
          {policyLiabilityJacket && (
            <>
              <Typography variant="body1" className={clsx(classes.mb1, classes.fontSizeNormal)}>
                <strong className={classes.minWidth}>Authority Limit:</strong>
                {Number(policyLiabilityJacket?.authLimit).toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                })}
              </Typography>
              <Typography variant="body1" className={clsx(classes.mb1, classes.fontSizeNormal)}>
                <strong className={classes.minWidth}>Policy Amount:</strong>
                {Number(policyLiabilityJacket?.liabilityAmount).toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                })}
              </Typography>
            </>
          )}
          <OrderInsightAlert
            isPdf={isPdf}
            alerts={alertRisks}
            warnings={warningRisks}
            unknowns={unknownRisks}
            errors={errorRisks}
          />
        </div>
      </div>
    </div>
  );
};

export default PolicyLiability;
